import { instance } from "api/apiBase";
import { Application } from "types/application";

export const applicationApi = {
  assignApplication: async ({
    application_id,
    assignee_ids
  }: {
    application_id: number;
    assignee_ids: number[];
  }): Promise<Application> => {
    const { data } = await instance.post<Application>(
      "/portal/v1/applications/bulk_assign",
      {
        application_ids: [application_id],
        assignee_ids
      }
    );
    return data;
  },

  bulkAssignApplications: async ({
    application_ids,
    assignee_ids
  }: {
    application_ids: number[];
    assignee_ids: number[];
  }): Promise<Application> => {
    const { data } = await instance.post<Application>(
      "/portal/v1/applications/bulk_assign",
      {
        application_ids,
        assignee_ids
      }
    );
    return data;
  },

  bulkChangeStage: async ({
    application_ids,
    stage_id
  }: {
    application_ids: number[];
    stage_id: number | null;
  }) => {
    const { data } = await instance.post(
      "/portal/v1/applications/bulk_change_stage",
      { application_ids, stage_id }
    );
    return data;
  }
};
